import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPrint, FaWhatsapp, FaShieldAlt, FaFileContract } from 'react-icons/fa';

const ContratoPage = () => {
  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/5582996992182?text=' + encodeURIComponent('Olá! Tenho dúvidas sobre o Contrato de Prestação de Serviços da CriaApp.'), '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-4xl mx-auto">
        
        {/* Barra superior de ações */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8 print:hidden">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-4 py-2 bg-white text-gray-700 hover:text-gray-900 rounded-xl shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors text-sm font-medium"
          >
            <FaArrowLeft className="text-xs" />
            Voltar
          </button>

          <div className="flex items-center gap-3">
            <button
              onClick={handlePrint}
              className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-xl shadow-sm hover:bg-black transition-colors text-sm font-medium"
            >
              <FaPrint className="text-xs" />
              Imprimir / Salvar PDF
            </button>
            <button
              onClick={openWhatsApp}
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] text-white rounded-xl shadow-sm hover:bg-[#20bd5a] transition-colors text-sm font-medium"
            >
              <FaWhatsapp className="text-base" />
              Falar com Suporte
            </button>
          </div>
        </div>

        {/* Documento do Contrato */}
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 border border-gray-200/80 text-gray-800 leading-relaxed print:shadow-none print:border-none print:p-0">
          
          {/* Cabeçalho Oficial */}
          <div className="border-b border-gray-200 pb-8 mb-8 text-center sm:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-semibold mb-4 border border-blue-200">
              <FaFileContract className="text-blue-600" />
              Documento Jurídico Vinculante
            </div>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 leading-tight">
              INSTRUMENTO PARTICULAR DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS TECNOLÓGICOS, CONVERSÃO DE APLICATIVO MÓVEL, LICENCIAMENTO DE SOFTWARE (SaaS) E MANUTENÇÃO CONTÍNUA
            </h1>
            <p className="text-xs text-gray-500 mt-3 font-mono">
              Registrado sob as normas do Código Civil Brasileiro, Lei do Software (Lei nº 9.609/1998) e Marco Civil da Internet (Lei nº 12.965/2014) • Última revisão: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>

          {/* Destaque Importante */}
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8 rounded-r-xl text-amber-900 text-sm">
            <p className="font-bold flex items-center gap-2 mb-1">
              <FaShieldAlt className="text-amber-600 flex-shrink-0" />
              Aviso de Validade Jurídica e Fidelidade
            </p>
            <p className="text-xs text-amber-800 leading-relaxed">
              O presente contrato possui vigência mínima de 12 (doze) meses de fidelidade em virtude dos custos de compilação, engenharia e infraestrutura investidos inicialmente pela CriaApp. A adesão aperfeiçoa-se com o cadastro, confirmação via canais oficiais ou pagamento da primeira mensalidade.
            </p>
          </div>

          {/* Corpo do Contrato */}
          <div className="space-y-8 text-sm sm:text-base text-gray-700">

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">DAS PARTES</h2>
              <p className="mb-2">
                <strong>CONTRATADA:</strong> <strong>CRIAAPP TECNOLOGIA / CRIAAPP OFICIAL</strong>, plataforma digital de desenvolvimento e conversão de aplicativos, acessível via <em>https://criaapp.com</em>, com canais oficiais de suporte técnico e faturamento operados via WhatsApp (+55 82 99699-2182) e e-mail criaappoficial@gmail.com, doravante denominada simplesmente <strong>"CONTRATADA"</strong>.
              </p>
              <p>
                <strong>CONTRATANTE:</strong> A pessoa física ou jurídica devidamente qualificada no ato de cadastro no sistema ou nos canais digitais de atendimento da CONTRATADA, legítima titular e responsável pelo endereço virtual (URL) submetido à conversão, doravante denominada <strong>"CONTRATANTE"</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 1ª – DO OBJETO</h2>
              <p className="mb-3">
                1.1. O presente Contrato tem por objeto a prestação de serviços de tecnologia para conversão, estruturação, compilação e adaptação do website do CONTRATANTE em formato de aplicativo móvel para sistemas operacionais <strong>Android</strong> (pacotes .AAB / .APK) e/ou <strong>iOS</strong> (pacotes .IPA / compilação Apple).
              </p>
              <p className="mb-3">
                1.2. Abrange o licenciamento temporário de uso da plataforma SaaS CriaApp, englobando dashboard de gestão, integração com WebView nativa de alta performance, sistema de menu inferior com ícones personalizados, tela de abertura (splash screen) e módulo de notificações push em massa.
              </p>
              <p>
                1.3. A CONTRATADA fornece a infraestrutura de compilação e sustentação de software, não exercendo controle e nem possuindo qualquer responsabilidade sobre o conteúdo, produtos, pagamentos ou serviços comercializados dentro do website do CONTRATANTE.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 2ª – DO ESCOPO TÉCNICO E ATUALIZAÇÕES</h2>
              <p className="mb-3">
                2.1. O serviço inclui a geração do aplicativo com WebView nativa acelerada, configuração de ícone, cores corporativas, tela de abertura e suporte para publicação nas lojas Google Play Store e Apple App Store.
              </p>
              <p>
                2.2. A CONTRATADA garante atualizações periódicas de compatibilidade para assegurar a conformidade do aplicativo com as novas versões do Android (Android 14, 15+) e iOS (iOS 17, 18+).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 3ª – DA VIGÊNCIA E FIDELIDADE OBRIGATÓRIA (12 MESES)</h2>
              <p className="mb-3">
                3.1. Este contrato é celebrado pelo <strong>prazo mínimo e determinado de 12 (doze) meses de fidelidade contratual</strong>, iniciando-se na data da confirmação do pedido ou quitação da primeira mensalidade.
              </p>
              <p className="mb-3">
                3.2. <strong>Justificativa da Fidelidade:</strong> A fidelidade mínima é justificada pelo investimento financeiro e técnico despendido imediatamente pela CONTRATADA (compilação em servidores de alta capacidade, alocação de engenheiros de software, certificados digitais e suporte de homologação), cujo custo é diluído ao longo das mensalidades.
              </p>
              <p>
                3.3. Ao término dos 12 meses, o contrato será prorrogado automaticamente por períodos sucessivos de igual duração, caso não haja manifestação expressa em contrário de qualquer das partes com 30 (trinta) dias de antecedência.
              </p>
            </section>

            <section className="bg-red-50/60 p-5 rounded-xl border border-red-200">
              <h2 className="text-lg font-bold text-red-900 mb-3 border-b border-red-200 pb-2">CLÁUSULA 4ª – DO CANCELAMENTO ANTECIPADO E MULTA RESCISÓRIA</h2>
              <p className="mb-3 text-red-950 font-medium">
                4.1. O cancelamento unilateral ou rescisão voluntária por iniciativa do CONTRATANTE antes do término dos 12 (doze) meses de fidelidade sujeitará o mesmo ao pagamento obrigatório de <strong>MULTA RESCISÓRIA COMPENSATÓRIA de 30% (trinta por cento)</strong> incidente sobre o valor total da soma de todas as mensalidades restantes até o final do contrato.
              </p>
              <p className="text-xs text-red-900 leading-relaxed">
                4.2. A multa compensatória visa cobrir os prejuízos e custos operacionais de desenvolvimento incorridos pela CONTRATADA, sendo condição prévia indispensável para a desativação regular dos serviços e liberação de pendências.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 5ª – DOS PAGAMENTOS E REAJUSTES</h2>
              <p className="mb-3">
                5.1. O CONTRATANTE pagará o valor da mensalidade estipulado no plano contratado (Plano Mensal ou Anual com desconto) através de PIX, transferência bancária ou meios digitais autorizados pela CriaApp.
              </p>
              <p>
                5.2. As mensalidades serão corrigidas anualmente pelo IGP-M/FGV ou IPCA acumulado, garantindo o equilíbrio econômico-financeiro da infraestrutura.
              </p>
            </section>

            <section className="bg-amber-50/60 p-5 rounded-xl border border-amber-200">
              <h2 className="text-lg font-bold text-amber-950 mb-3 border-b border-amber-200 pb-2">CLÁUSULA 6ª – DA INADIMPLÊNCIA E SUSPENSÃO DO APP</h2>
              <p className="mb-3 text-amber-950">
                6.1. O atraso no pagamento sujeitará o débito a multa moratória de 2% (dois por cento) e juros de 1% (um por cento) ao mês, além de correção monetária.
              </p>
              <p className="mb-3 text-amber-950">
                6.2. <strong>Suspensão Operacional (5 Dias):</strong> Constatado atraso superior a <strong>5 (cinco) dias corridos</strong>, a CONTRATADA suspenderá preventivamente o funcionamento do aplicativo móvel, painel de controle e envio de notificações push.
              </p>
              <p className="text-xs text-amber-900 leading-relaxed">
                6.3. <strong>Cancelamento Definitivo (15 Dias):</strong> Decorridos <strong>15 (quinze) dias corridos</strong> de inadimplência, o contrato será rescindido de pleno direito por culpa do CONTRATANTE, com vencimento antecipado das mensalidades remanescentes somadas à multa rescisória de 30%, despublicação do app e remessa do débito para cobrança extrajudicial, órgãos de restrição ao crédito (SPC/Serasa) e execução judicial.
              </p>
            </section>

            <section className="bg-blue-50/60 p-5 rounded-xl border border-blue-200">
              <h2 className="text-lg font-bold text-blue-950 mb-3 border-b border-blue-200 pb-2">CLÁUSULA 7ª – CLÁUSULA BLINDADA ANTI-CONTESTAÇÃO (ANTI-CHARGEBACK)</h2>
              <p className="mb-3 text-blue-950 font-medium">
                7.1. O CONTRATANTE reconhece expressamente que os serviços de compilação, engenharia de software e disponibilização de infraestrutura têm início imediato após o pedido. Uma vez gerado o aplicativo ou concedido acesso, o serviço considera-se integralmente consumido.
              </p>
              <p className="mb-3 text-blue-950">
                7.2. É terminantemente proibida a abertura de contestações injustificadas (*chargebacks*) ou solicitações de estorno junto a operadoras e bancos após o fornecimento do serviço.
              </p>
              <p className="text-xs text-blue-900 leading-relaxed">
                7.3. Em caso de estorno ou contestação indevida, o CONTRATANTE obriga-se a reembolsar o montante em 48 horas, acrescido de <strong>multa punitiva de 50% (cinquenta por cento)</strong> sobre o valor contestado, ressarcimento das tarifas bancárias e indenização por perdas e danos decorrentes de litigância de má-fé.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 8ª – RESPONSABILIDADE SOBRE O CONTEÚDO</h2>
              <p className="mb-3">
                8.1. O CONTRATANTE é o único e exclusivo responsável pelo conteúdo, legalidade, produtos, marcas e atividades comerciais praticadas em seu website e aplicativo.
              </p>
              <p>
                8.2. É vedado o uso da plataforma para fins ilícitos, pirataria, jogos de azar não autorizados, pornografia ou qualquer prática que afronte a legislação brasileira ou as diretrizes da Google Play e Apple App Store.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 9ª – PROPRIEDADE INTELECTUAL</h2>
              <p className="mb-3">
                9.1. A tecnologia CriaApp, seus algoritmos, layout, dashboard e códigos-fonte pertencem exclusivamente à CONTRATADA, concedendo-se ao CONTRATANTE apenas licença temporária de uso enquanto adimplente.
              </p>
              <p>
                9.2. A marca, logotipo e conteúdos do website permanecem como patrimônio exclusivo do CONTRATANTE.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 10ª – VALIDADE DO ACEITE ELETRÔNICO</h2>
              <p>
                10.1. O presente instrumento é válido e vinculante sob as diretrizes do Art. 10, § 2º, da Medida Provisória nº 2.200-2/2001 e Art. 427 do Código Civil, aperfeiçoando-se por meio do clique de aceite, confirmação via WhatsApp oficial ou pagamento da primeira mensalidade.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-900 mb-3 border-b border-gray-100 pb-2">CLÁUSULA 11ª – DO FORO DE ELEIÇÃO</h2>
              <p>
                11.1. Para dirimir quaisquer litígios oriundos deste Contrato, as partes elegem, com renúncia expressa a qualquer outro por mais privilegiado que seja, o Foro da Comarca da sede da CONTRATADA.
              </p>
            </section>

          </div>

          {/* Rodapé de Assinatura */}
          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500 gap-4">
            <div>
              <p className="font-bold text-gray-700">CRIAAPP TECNOLOGIA</p>
              <p>Suporte e Atendimento Oficial: +55 (82) 99699-2182</p>
            </div>
            <div className="text-center sm:text-right">
              <p>Documento disponível publicamente em</p>
              <a href="https://criaapp.com/contrato" className="text-blue-600 hover:underline">https://criaapp.com/contrato</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContratoPage;
